import { useFormContext, useDependedFieldsValueControl } from '@sravni/cosago-react-library/lib/hooks';

import { useAppDispatch } from 'shared/lib';

import { setMfoInfo } from 'entities/mfo/model/mfoForm.slice';

export function useMfoFieldsControl() {
  const { watch } = useFormContext();
  const dispatch = useAppDispatch();

  const amount = watch('amount');
  const period = watch('period');
  const snils = watch('snils');

  useDependedFieldsValueControl({
    fieldName: 'amount',
    onValueChangeAction: [
      () => {
        dispatch(setMfoInfo({ amount }));
      },
    ],
  });

  useDependedFieldsValueControl({
    fieldName: 'period',
    onValueChangeAction: [
      () => {
        dispatch(setMfoInfo({ period }));
      },
    ],
  });

  useDependedFieldsValueControl({
    fieldName: 'snils',
    onValueChangeAction: [
      () => {
        dispatch(setMfoInfo({ snils }));
      },
    ],
  });
}
